class Menu {
  constructor (props) {
    this.menu = [
      {
        title: 'Dashboard',
        icon: 'fa-dashboard',
        single: true,
        location: '#/dashboard'
      }, {
        title: 'Search',
        icon: 'fa-search',
        single: true,
        location: '#/search'
      }, {
        title: 'Orders',
        icon: 'fa-first-order',
        single: true,
        location: '#/orders'
      }, {
        title: 'Order Events',
        icon: 'fa-sliders',
        single: true,
        location: '#/events'
      }, {
        title: 'Tickets',
        icon: 'fa-ticket',
        single: true,
        location: '#/ticket'
      }, {
        admin: true,
        title: 'Users',
        icon: 'fa-users',
        single: true,
        location: '#/users'
      }
    ]
  }

  getMenu (endpoints, system) {
    if (endpoints.hasOwnProperty('accesses')) this.menu.splice(2, 0, { admin: false, title: 'Accesses', icon: 'fa-home', single: true, location: '#/access' })
    
    return this.menu
  }
}
export default new Menu()



// WEBPACK FOOTER //
// ./src/projects/access-gui/config/menu.js